import { InsightType } from 'lib/apis/entity/insight';
import { Dispatch, SetStateAction } from 'react';
import HousePricesTrendsTimeInterval from './housePricesTrendsTimeInterval';
import HousePricesTrendsType from './housePricesTrendsType';

type Props = {
  timeInterval: number;
  setTimeInterval: Dispatch<SetStateAction<number>>;
  mode: InsightType.TrendMode;
  setMode: Dispatch<SetStateAction<InsightType.TrendMode>>;
};

const HousePricesTrendsOptions = ({
  timeInterval,
  setTimeInterval,
  mode,
  setMode,

}: Props) => {

  return (
    <>
      <HousePricesTrendsTimeInterval
        timeInterval={timeInterval}
        setTimeInterval={setTimeInterval}
      />
      <div className="flex flex-row flex-wrap items-center justify-between lg:gap-2 gap-5 w-full">
        <HousePricesTrendsType mode={mode} setMode={setMode} />
        {/* <HousePricesTrendsPriceIndex
          trendsConfig={trendsConfig}
          trendType={trendType}
          setTrendType={setTrendType}
        /> */}
      </div>
    </>
  );
};
export default HousePricesTrendsOptions;
